"use client";

import { Trans, useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import Image from "next/image";
import heroImage from "@/assets/hero-community.png";

const HeroSection = () => {
  const { t } = useTranslation();

  return (
    <section className="relative pt-32 pb-20 overflow-hidden">
      {/* Blob decorations */}
      <div className="absolute top-20 -left-32 w-96 h-96 bg-primary/20 blob-shape animate-blob-morph blur-3xl" />
      <div className="absolute bottom-0 -right-32 w-80 h-80 bg-accent/15 blob-shape animate-blob-morph blur-3xl" style={{ animationDelay: "2s" }} />
      <div className="absolute top-40 right-20 w-48 h-48 bg-secondary/10 blob-shape animate-blob-morph blur-2xl" style={{ animationDelay: "4s" }} />

      <div className="container mx-auto px-6 relative">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left: copy */}
          <div className="text-center lg:text-left">
            {/* Heading */}
            <h1 className="font-heading font-extrabold text-4xl md:text-5xl lg:text-5xl xl:text-6xl leading-[1.1] tracking-tight mb-6 animate-fade-up" style={{ animationDelay: "0.2s" }}>
              <Trans
                i18nKey="hero.title"
                components={{ gradient: <span className="text-gradient" /> }}
              />
            </h1>

            {/* Subheading */}
            <p className="text-lg md:text-xl text-muted-foreground mb-10 animate-fade-up" style={{ animationDelay: "0.3s" }}>
              {t("hero.subtitle")}
            </p>

            {/* CTA */}
            <div className="flex flex-col sm:flex-row items-center lg:items-start justify-center lg:justify-start gap-4 animate-fade-up" style={{ animationDelay: "0.4s" }}>
              <Button variant="hero" size="lg" className="group" asChild>
                <a href={process.env.NEXT_PUBLIC_REGISTER_URL}>
                  {t("hero.tryFree")}
                  <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" aria-hidden="true" />
                </a>
              </Button>
              <Button variant="outline" size="lg" asChild>
                <a href={process.env.NEXT_PUBLIC_BOOKING_URL}>
                  {t("hero.bookDemo")}
                </a>
              </Button>
            </div>
          </div>

          {/* Right: image */}
          <div className="relative animate-fade-up" style={{ animationDelay: "0.3s" }}>
            <div className="relative rounded-3xl overflow-hidden shadow-2xl border-2 border-border aspect-square">
              <Image
                src={heroImage}
                alt={t("hero.imageAlt")}
                fill
                priority
                className="object-cover"
              />
            </div>
            {/* Decorative accents */}
            <div className="absolute -top-6 -right-6 w-24 h-24 bg-primary/30 blob-shape blur-2xl -z-10" />
            <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-accent/30 blob-shape blur-2xl -z-10" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
